module.exports = __webpack_public_path__ + "static/logo-text-2-1a6c90d405dd2f5da3e09eb9abab60d5.png";